<div class="layout py-12">

  <div class="md:grid grid-cols-2 md:gap-20 py-6 md:py-12">

    <div class="min-h-72 h-full w-full relative self-center order-last">


      <img fill="" class="object-cover rounded-lg" alt="" loading="lazy"
           ngSrc="assets/images/societe/entreprise.webp">
    </div>
    <div class="lg:py-20 py-8 flex justify-center flex-col"><h3
      class="font-bold mb-9 text-3xl leading-tight text-bleuCaliceo-300 uppercase">
      {{ 'aboutUs.title1' | translate }}
    </h3>
      <p class="font-medium text-gray-500 text-md whitespace-pre-line"
         [innerHtml]="'aboutUs.description1' | translate"></p></div>

  </div>


  <div class="md:grid grid-cols-2 md:gap-20 py-6 md:py-12">
    <div class="min-h-72 h-full w-full relative self-center">


      <img fill="" class="object-cover rounded-lg" alt="" loading="lazy"
           ngSrc="assets/images/societe/bains.webp">
    </div>
    <div class="lg:py-20 py-8 flex justify-center flex-col">


      <p class="font-medium text-gray-500 text-md whitespace-pre-line" [innerHtml]="'aboutUs.universes' | translate">
      </p>
      <h3
        class="font-bold mt-7 mb-3 text-2xl leading-tight text-bleuCaliceo-300 uppercase"
        [innerHtml]="'baths' | translate"></h3>
      <p class="font-medium text-gray-500 text-md whitespace-pre-line" [innerHtml]="'aboutUs.baths' | translate">

      </p>
      <h3
        class="font-bold mt-6 mb-2 text-2xl leading-tight text-bleuCaliceo-300 uppercase"
        [innerHtml]="'spa' | translate"></h3>
      <p class="font-medium text-gray-500 text-md whitespace-pre-line" [innerHtml]="'aboutUs.spa' | translate"></p>

      <h3
        class="font-bold mt-6 mb-2 text-2xl leading-tight text-bleuCaliceo-300 uppercase"
        [innerHtml]="'vitality' | translate"></h3>

      <p class="font-medium text-gray-500 text-md whitespace-pre-line" [innerHtml]="'aboutUs.vitality' | translate">


      </p>
    </div>


  </div>


  <div class="md:grid grid-cols-2 md:gap-20 py-6 md:py-12">

    <div class="min-h-72 h-full w-full relative self-center order-last">
      <img fill="" class="object-cover rounded-lg" alt="" loading="lazy"
           ngSrc="assets/images/societe/notre-developpement.webp">
    </div>


    <div class="lg:py-20 py-8 flex justify-center flex-col">


      <p class="font-medium text-gray-500 text-md whitespace-pre-line">
      <h3
        class="font-bold mt-2 mb-7 text-3xl leading-tight text-bleuCaliceo-300 uppercase"
        [innerHtml]="'aboutUs.title2' | translate"></h3>
      <p class="font-medium text-gray-500 text-md whitespace-pre-line" [innerHtml]="'aboutUs.description2' | translate">


      </p>

    </div>


  </div>


  <div class="md:grid grid-cols-2 md:gap-20 py-6 md:py-12">
    <div class="min-h-72 h-full w-full relative self-center">


      <img fill="" class="object-cover rounded-lg" alt="" loading="lazy"
           ngSrc="assets/images/societe/sante-preventive.webp">
    </div>
    <div class="lg:py-20 py-8 flex justify-center flex-col">


      <p class="font-medium text-gray-500 text-md whitespace-pre-line">

      <h3
        class="font-bold mt-2 mb-7 text-3xl leading-tight text-bleuCaliceo-300 uppercase"
        [innerHtml]="'aboutUs.title3' | translate"></h3>
      <p class="font-medium text-gray-500 text-md whitespace-pre-line" [innerHtml]="'aboutUs.description3' | translate">
      </p>

    </div>


  </div>


</div>
